import { createFeatureAreaResolver } from '@cast/infrastructure-monitoring';

const externalClustersMatcher = ([
  _exernalClusters,
  _clusterId,
  feature,
  subFeature,
]: Array<string | undefined>): string => {
  if (subFeature === 'pod-mutations') {
    return 'pricing';
  }

  switch (feature) {
    case 'dashboard':
      return 'reporting';
    case 'cluster-score':
    case 'cost-report':
    case 'available-savings':
    case 'savings':
      return 'reporting';
    case 'nodes':
      return 'kube';
    case 'autoscaler':
      return 'autoscaler';
    case 'workload-optimization':
      return 'woop';
    case 'rebalance':
      return 'autoscaler';
    case 'audit':
      return 'wire';
    default:
      return '-';
  }
};

export const getFeatureArea = createFeatureAreaResolver({
  dashboard: 'kube',
  commitments: 'pricing',
  notifications: 'wire',
  optimization: 'pricing',
  llm: 'ai-optimzer',
  dbo: 'poly',
  'user/api-access': 'wire',
  'external-clusters': externalClustersMatcher,
  'network-intelligence': 'reporting',
  'organization/security': 'security',
  'organization/cost-report': 'reporting',
  'organization/management': 'wire',
  'organization/enterprise': 'wire',
  'settings/scheduled-rebalancing': 'autoscaler',
  'settings/cluster-hibernation': 'autoscaler',
  settings: 'wire',
});
